import { Button } from "./Button";

/**
 * PPRD: Pricing & Plans, Request a Demo Buttons
 */
export const PPRD = () => {
  return (
    <div className="flex flex-col w-full md:w-fit md:flex-row gap-5">
      <Button className="text-lg" href="/pricing">
        Pricing & Plans
      </Button>
      <Button
        className="text-lg"
        outlined
        href="https://calendly.com/dustint12/30min"
      >
        Request a Demo
      </Button>
    </div>
  );
};
